import { ref, computed, InjectionKey } from 'vue';
import { defineStore } from 'pinia';
import { AemAssetMap, ForgotPassword } from '@/types';

export const useLoginHelpStore = defineStore('loginHelpStore', () => {
    // ? STATE
    const userDetails = ref<ForgotPassword>({ 'dob': '', 'username': '' });
    const aemAssets = ref<AemAssetMap>({});

    // ? GETTERS
    const getUserDetails = computed(() => userDetails.value);

    // ? ACTIONS / SETTERS
    function setUserDetails(userInfo: ForgotPassword) {
        userDetails.value.dob = userInfo.dob ? userInfo.dob : '';
        userDetails.value.username = userInfo.username ? userInfo.username : '';
    }

    function setAemAssets(newAemAssets: AemAssetMap) {
        aemAssets.value = newAemAssets;
    }

    function reset() {
        userDetails.value.dob = '';
        userDetails.value.username = '';
    }

    return {
        //getter
        getUserDetails,
        //setter
        setUserDetails,
        aemAssets,
        setAemAssets,
        reset,
    };
});

export const LoginHelpStoreKey: InjectionKey<() => LoginHelpStore> = Symbol('loginHelpStore');
export type LoginHelpStore = ReturnType<typeof useLoginHelpStore>;
